import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, catchError, map, switchMap } from 'rxjs';

import { initHubspot } from '../../lib/hubspot';
import { CustomizableBannerService } from '../core/services/customizable-banner.service';
import { PostHogService } from '../core/services/posthog.service';
import { SnackbarService } from '../core/services/snackbar.service';
import { SourceResourceService } from '../core/services/source-resource.service';
import { UserService } from '../core/services/user.service';
import { ID } from '../models/id';

export function initializer(
  userService: UserService,
  snackbarService: SnackbarService,
  customizableBannerService: CustomizableBannerService,
  postHogService: PostHogService,
  sourceResourceService: SourceResourceService,
): () => Observable<boolean> {
  return () => {
    const company = getCompanyAndRemoveCompanyQueryParam();
    sourceResourceService.captureSourceResourceFromUrl();
    return userService.fetchUser(company).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 502) {
          snackbarService.error('API is unavailable');
        }
        return throwError(error);
      }),
      switchMap((user) => {
        if (user?.id) {
          initHubspot(user);
        }
        return postHogService.init().pipe(map(() => user));
      }),
      switchMap((user) => customizableBannerService.fetchCustomizableBanners(user)),
      map(() => true),
    );
  };
}

function getCompanyAndRemoveCompanyQueryParam(): ID {
  const currentUrl = new URL(window.location.href);
  const hasCompanyParam = currentUrl.searchParams.has('membership_company');
  const company = hasCompanyParam ? Number(currentUrl.searchParams.get('membership_company')) : null;
  if (hasCompanyParam) {
    currentUrl.searchParams.delete('membership_company');
    history.replaceState({}, '', currentUrl);
  }

  return company;
}
